export default "__VITE_ASSET__Cdip2K93__"